/* eslint-disable */ import { DomainBuilder, DomainComponentOpticBuilder, InvariantBuilder, RecipeFactoryBuilder, createConstantExpressionFactory, createCustomExpressionFactory, createCustomInvariantFactory, createRelationFactory } from '@salsita-ai/platform-project-sdk/domain';
import { BackendData, FrontendData, PublishedData, SessionData } from './application-types.js';
import { $entityReflections, constants } from './enhanced-model.js';
import { AnyDomainEntity, RootEntity, aliases, entities, modelVersion } from './model/index.js';
const implementRelation = createRelationFactory(aliases);
export const relationExpressions = {
    Table: {
        $top: implementRelation({
            kind: 'direct',
            field: 'topId',
            target: 'Top',
            cardinality: '1-1'
        }),
        $legs: implementRelation({
            kind: 'direct',
            field: 'legsId',
            target: 'Legs',
            cardinality: '1-1'
        })
    },
    Top: {
        $table: implementRelation({
            kind: 'indirect',
            field: 'topId',
            target: 'Table',
            cardinality: '1-1'
        })
    },
    Legs: {
        $table: implementRelation({
            kind: 'indirect',
            field: 'legsId',
            target: 'Table',
            cardinality: '1-1'
        })
    }
};
export const constantExpressions = createConstantExpressionFactory({} // insert expression metas here, once ready
)(constants);
export const createRecipe = RecipeFactoryBuilder.forAliases(aliases).forEntities(AnyDomainEntity.reflections).withDefaults({
    OakLegs: {
        color: 'UltraMatteLak'
    },
    SteelLegs: {
        color: 'RAL9005'
    },
    LegsClassico: {
        legOffset: 500
    },
    LegsWithOffsetStandardDefault: {
        legOffset: 400
    },
    LegsWithThickness: {
        legThickness: 'Thick'
    },
    Top: {
        color: 'UltraMatteLak',
        edgeFinish: 'Standard',
        material: 'SolidOak',
        fenixVariant: 'None',
        thickness: 40,
        topFinish: 'NewOak'
    },
    TopCircle: {
        diameter: 1300
    },
    TopWithLengthAndWidth: {
        length: 2400,
        width: 1200
    }
}).build();
const staticViolations = {
    Top: {
        fenixTopWithoutVariant: {
            type: 'fenixTopWithoutVariant',
            severity: 'fatal',
            message: {
                id: "lruN3B",
                message: "Fenix table tops must have a variant selected."
            }
        },
        oakTopWithoutFinish: {
            type: 'oakTopWithoutFinish',
            severity: 'fatal',
            message: {
                id: "XkY7ie",
                message: "Oak table tops must have a finish selected."
            }
        },
        roundEdgeFinishNotSupported: {
            type: 'roundEdgeFinishNotSupported',
            severity: 'fatal',
            message: {
                id: "TaCFK6",
                message: "The round edge finish is only available for solid oak."
            }
        },
        thicknessNotAvailableForThisMaterial: {
            type: 'thicknessNotAvailableForThisMaterial',
            severity: 'fatal',
            message: {
                id: "D3ESub",
                message: "This thickness is not available for this material."
            }
        },
        topColorNotAvailableForThisMaterial: {
            type: 'topColorNotAvailableForThisMaterial',
            severity: 'fatal',
            message: {
                id: "e39FIV",
                message: "This top color is not available for this material."
            }
        },
        topFinishNotAvailableForThisMaterial: {
            type: 'topFinishNotAvailableForThisMaterial',
            severity: 'fatal',
            message: {
                id: "QJrmFJ",
                message: "This top finish is not available for this material."
            }
        },
        diameterNotAvailableForThisMaterial: {
            type: 'diameterNotAvailableForThisMaterial',
            severity: 'fatal',
            message: {
                id: "v9M6dI",
                message: "This diameter is not available for this material."
            }
        }
    },
    Legs: {
        oakLegsAndTopColorNotMatching: {
            type: 'oakLegsAndTopColorNotMatching',
            severity: 'fatal',
            message: {
                id: "xtMGbU",
                message: "If the The legs and top are both made of oak, they must have the same color."
            }
        },
        topMaterialNotSupported: {
            type: 'topMaterialNotSupported',
            severity: 'fatal',
            message: {
                id: "DAs7HJ",
                message: "This table top material can not be combined with this leg style."
            }
        },
        topShapeNotSupported: {
            type: 'topShapeNotSupported',
            severity: 'fatal',
            message: {
                id: "xORCIs",
                message: "This table top shape can not be combined with this leg style."
            }
        },
        tooCloseToEndOfTable: {
            type: 'tooCloseToEndOfTable',
            severity: 'fatal',
            message: {
                id: "yoeEki",
                message: "This combination of width and distance from the end of the table is not possible."
            }
        }
    }
};
export const implementCustomInvariants = createCustomInvariantFactory()(staticViolations);
export const invariantBuilder = new InvariantBuilder(aliases);
export const attachComponent = DomainComponentOpticBuilder.from(aliases);
export const implementCustomExpressions = createCustomExpressionFactory({} // TODO pass in meta-data once we have them
);
export const domainBuilder = DomainBuilder.from(entities, aliases, $entityReflections, RootEntity.types, modelVersion, PublishedData, SessionData, FrontendData, BackendData, false).withExpressions(constantExpressions).withExpressions(relationExpressions);

//# sourceMappingURL=implementation.js.map